export default "__VITE_ASSET__BV4HUDHo__"